import React, { useState } from "react"
import SwiperCore, { Pagination, Navigation, Thumbs } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"

import GatsbyStoryblokImage from "../../../elements/V2/GatsbyStoryblokImage"
import "./styles.css"
import Video from "../../../elements/V2/Video"

SwiperCore.use([Pagination, Navigation, Thumbs])

export type GalleryProps = {
  galleryItems: Storyblok.ProductGallery[]
}

const ProductInfoSectionGallery = ({ galleryItems }: GalleryProps) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore>()

  return (
    <>
      <Swiper
        slidesPerView={1.2}
        slidesOffsetBefore={20}
        slidesOffsetAfter={20}
        spaceBetween={20}
        breakpoints={{
          667: {
            slidesPerView: galleryItems?.length >= 2 ? 2 : 1,
            spaceBetween: 10,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          },
          900: {
            height: 600,
            slidesPerView: 1,
            spaceBetween: 10,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        }}
        thumbs={{ swiper: thumbsSwiper }}
        grabCursor={true}
        loop={false}
        enabled={galleryItems.length > 1}
      >
        {galleryItems?.map((galleryItem, index) => (
          <SwiperSlide
            key={index}
            className="!flex items-center justify-center rounded-16 bg-light-gray"
          >
            {galleryItem.video?.filename ? (
              <Video
                video={galleryItem.video?.filename || ""}
                coverImage={galleryItem.image.filename}
                ImageAlt={"image"}
                loadType="eager"
                aspectRatio="4:3"
                playbackMode="autoplay"
                rounded
                playOnMobile={false}
              />
            ) : (
              <GatsbyStoryblokImage
                image={galleryItem.image.filename}
                alt={galleryItem.image.alt || "Product thumbnail"}
                aspectRatio="4:3"
                quality={80}
                rounded
                testId="gallery-slide-image"
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      {galleryItems.length > 1 && (
        <Swiper
          centerInsufficientSlides
          className="thumbs-swiper mt-20 hidden md:block"
          onSwiper={(swiper) => setThumbsSwiper(swiper)}
          spaceBetween={8}
          watchSlidesProgress={true}
          slidesPerView={4.55}
          breakpoints={{
            1200: {
              slidesPerView: 5,
            },
          }}
        >
          {galleryItems?.map((galleryItem, index) => (
            <SwiperSlide
              key={index}
              className="!flex max-w-[20.6%] cursor-pointer items-center justify-center overflow-hidden rounded-8 border border-transparent bg-light-gray"
            >
              <GatsbyStoryblokImage
                image={galleryItem.image.filename}
                alt={galleryItem.image.alt || "Product thumbnail"}
                aspectRatio="4:3"
                testId="gallery-slide-thumbnail-image"
              />
            </SwiperSlide>
          ))}
          <div className="absolute right-0 top-0 z-10 -mr-2 hidden h-full w-1/12 bg-gradient-to-l from-white from-15% to-transparent md:block lg:hidden"></div>
        </Swiper>
      )}
    </>
  )
}

export default ProductInfoSectionGallery
